import { reducersActions } from "../actions/new-actions";

const {
  FETCH_BRANDS_REQUEST,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAILURE,
} = reducersActions;

const initialState = {
  loading: false,
  brands: [],
  error: null,
};

const brandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRANDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_BRANDS_SUCCESS:
      return {
        ...state,
        loading: false,
        brands: action.payload,
        error: null,
      };
    case FETCH_BRANDS_FAILURE:
      return {
        ...state,
        loading: false,
        brands: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default brandsReducer;
